<div class="container w100" id="sidebar1" style="position: relative;width:4%;">
  <div class="sidebar accordion" id="sidebarAccordion">
    <div class="sidebar-stript">

      <nav class="sidebar-nav">
        <ul id="sidebarnav">
          <li id="sidemenuHome"> <a class="pointer" [class.activecolor]="activetab == 'Home'"
            (click)="mapComponent.setDefaultView()" data-toggle="tooltip" title="Home" 
            data-placement="right"><span class="di-home1" 
            style="font-size: 22px;display: block;margin-bottom: 8px; margin-top: 8px;"></span></a> </li>
          <li id="sidemenuTitleThree"> <a class="pointer" [class.activecolor]="activetab == 'filter'"
              (click)="activatesidemanu('sidemenuContentThree','sidemenuContentOne','sidemenuContentTwo','filter')"><i
                class="fa fa-filter" aria-hidden="true" data-toggle="tooltip" title="Filter" data-placement="right"
                style="font-size: 18px;display: block;margin-bottom: 5px;"></i> </a> </li>
          <li id="sidemenuTitleTwo"> <a class="pointer" [class.activecolor]="activetab == 'layer'"
              (click)="activatesidemanu('sidemenuContentTwo','sidemenuContentThree','sidemenuContentOne','layer')"
              data-toggle="tooltip" title="Layers" data-placement="right"><span class="di-layers"></span></a> </li>

          <li class="tablinks" id="downloadButton" ngbDropdown >
            <a class="pointer" data-toggle="tooltip" title="Download">
              <span  id="dropdownBasic1" ngbDropdownToggle><i
                class="fa fa-download" aria-hidden="true"></i></span>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button (click)="pdfDownload()" ngbDropdownItem>Authority Notification</button>
                  <button *ngIf="showuserManual" (click)="userManualDownload()" ngbDropdownItem>User Manual</button>
                  <button *ngIf="adminManualPdf" (click)="adminManualDownload()" ngbDropdownItem>Admin User Manual</button>
                  <!-- <button (click)="dgchindiManual()" ngbDropdownItem>About District Ganga Committee in Hindi</button>
                  <button (click)="dgcenglishManual()" ngbDropdownItem>About District Ganga Committee in English</button> -->
                  
                </div>
            </a>
            
          </li>

        </ul>
      </nav>
    </div>
    <div class="sidebar-collapse-menu-content">
      <div id="sidemenuContentOne" style="display:none" class="collapse">
        <div class="slide-box">
          <div class="slide-box-header px-3 py-2 d-flex align-items-center justify-content-between">
            <h3 class="flex-fill">Applications </h3>
            <a data-toggle="collapse" (click)="removeSideMenu('sidemenuContentOne')" aria-expanded="true"
              aria-controls="sidemenuContentOne" class="di-cross close"></a>
          </div>
          <div class="accordian_sidemenu">
          </div>
        </div>
      </div>
      <div id="sidemenuContentTwo" style="display:none" class="collapse">
        <div class="slide-box">
          <div class="sidescroll">
            <div class="slide-box-header px-3 py-2 d-flex align-items-center justify-content-between">
              <h3 class="flex-fill">{{'header.layers' | translate }}</h3>
              <a data-toggle="collapse" (click)="removeSideMenu('sidemenuContentTwo')" aria-expanded="true"
                aria-controls="sidemenuContentOne" class="di-cross close"></a>
            </div>


            <div class="tab" role="tabpanel">
              <!-- <ul class="nav menunav-tabs mt-1 border-bottom" role="tablist">
                <li role="presentation"><a class="pointer inactivecolor"
                    [class.activecolor]="layerBoxActiveTab == 'overlays'" role="tab" data-toggle="tab"
                    (click)="setLayerBoxActiveTab('overlays')">{{'header.overlay' | translate}}</a></li>
                <li role="presentation"><a class="pointer inactivecolor"
                    [class.activecolor]="layerBoxActiveTab == 'layers'" role="tab" data-toggle="tab"
                    (click)="setLayerBoxActiveTab('overlays')">{{'header.baselayers' | translate}}</a></li>
              </ul> -->
            </div>
            <div [hidden]="layerBoxActiveTab == 'overlays'" class="card-body pb-0 collapse show tab-content-layer"
              id="monthlyTrend">
              <label class="layer-checkbox-container w-100 sidemenucheckbox1" *ngFor="let layer of baseLayers">
                  <div>
                    <span class="p-1 mr-1"><img src="assets/images/menu_map.png" width="40" height="40" class="rounded-circle"></span>
                    {{layer.displayName}}
                </div>
              </label>
            </div>
     
            <div [hidden]="layerBoxActiveTab == 'layers'" class="tab-pane">
              <div class="accordian_sidemenu" id="main_applications">
                <div *ngFor="let group of groupList |keyvalue">
                  <div class="slide-box-header px-3 py-2 d-flex align-items-center justify-content-between">
                    <div class="min-width" style="min-width: 100%">
                      <p class="card-title text-white text-left flex-fill">{{'infotab.' +group.key | translate}}<a
                          class="ml-3 right-collapse-button float-right" data-toggle="collapse" href="#Administrative"
                          role="button" aria-expanded="true" aria-controls="monthlyTrend"> <i class="di-collapse"></i>
                          <i class="di-expand"></i> 
                        </a> 
                      </p>
                    </div>
                  </div>
                  <div *ngFor="let layer of group.value" class="sidemenucheckbox">
                    <label class="layer-checkbox-container">
                      <input type="checkbox" (change)="mapComponent.toggleLayer(layer.name)"
                        [(ngModel)]="activeLayers[layer.name]" />
                      <div class="menu-checkbox">
                        {{'infotab.' +layer.displayName | translate}}
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      

      <div id="sidemenuContentThree" style="display:none" class="collapse">
        <div class="slide-box">
          <div class="slide-box-header px-3 py-2 d-flex align-items-center justify-content-between">
            <h3 class="flex-fill">{{'header.Filter-(Scoring)' | translate }}</h3>
            <a (click)="removeSideMenu('sidemenuContentThree')" class="di-cross close"></a>
          </div>

          <div class="col-12 mb-3">
            <label>{{'header.assesmentyear' | translate }}<span class="text-star">*</span></label>
            <select [(ngModel)]="filterOptions['assesmentyear']" class="form-control custom-selectbox">
              <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
            </select>
            <span style="color:red" [hidden]="validation['year']">Please Select assesmentyear </span>
          </div>
          <div class="col-12 mb-3">
            <label>{{'header.monthsmapping' | translate }}<span class="text-star">*</span></label>
            <select [(ngModel)]="filterOptions['month']" class="form-control custom-selectbox">
              <option value="" [disabled]="true">{{'monthmaps.selcecttag' | translate}}</option>
              <option  *ngFor="let month of monthsList"  [value]="month.key">
                {{'monthmaps.' + month['value'] | translate}}</option>
            </select>
            <span style="color:red" [hidden]="validation['month']">Please Select Month </span>
          </div>
          <!-- <div class="col-12 mb-3">
            <div class="form-group">
                <label>Data Submission</label>
                <select [(ngModel)]="datasubmitted" disabled="" (change)="dataSubmissionChange()" class="form-control custom-selectbox selectdis">
                  <option value="districtwise" >District Level</option>
              </select>
            </div>
        </div> -->
          <div class="col-12 mb-3">
              <label>{{'header.state' | translate }}</label><span class="text-star">*</span>
              <select placeholder="Select State" [(ngModel)]="selectedstate"(change) = "showdistrictdropdown(selectedstate)" class="form-control custom-selectbox" >
                <option value="null">{{'tabledataforstates.selectstate' | translate}}</option>
              <option *ngFor="let state of statelists"  value="{{state.uuid}}">{{'tabledataforstates.'+ state['name'] | translate}}</option>
          </select>
          <span style="color:red" [hidden]="validation['state']">{{'tabledataforstates.pleaseselectstate' | translate}} </span>
          </div>
          <div class="col-12 mb-3" *ngIf = "showdistdrop">
              <label>{{'header.district' | translate }}</label>
              <ng-multiselect-dropdown placeholder=" {{ 'districtsdata.select' | translate}}" 
              [data]="filterDropDownList['districtList']" [(ngModel)]="districtarray"
              [settings]="dropdownSetting" (onSelect)="onItemSelects($event)" (onSelectAll)="onSelectAlls($event)"
               (onDeSelect)="onItemDeSelects($event)" (onDeSelectAll)="onItemDeSelectAlls($event)">
              </ng-multiselect-dropdown>
              <span style="color:red" [hidden]="validation['district']">{{'districtsdata.pleaseselectdistrict' | translate}} </span>
          </div>

          <div class="col-12">
            <button (click)="submitdatafilter()" class="btn btn-success mt-4 btn-block">{{'header.submit' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>